module.exports = __webpack_public_path__ + "img/contact2.18b64c24.png";